var _circle, _path, _circle2, _path2, _circle3, _circle4, _circle5, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.26,
    cy: 7.938,
    r: 4.048
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.564 17.54v-.727a3.844 3.844 0 00-3.845-3.845h-6.918a3.844 3.844 0 00-3.845 3.845v.727"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 18.657,
    cy: 16.698,
    r: 1.445
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M21.279 37.32v-3.412"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 34.088,
    cy: 37.32,
    r: 1.31
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 21.26,
    cy: 37.32,
    r: 1.31
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 8.432,
    cy: 37.32,
    r: 1.31
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8.432 37.32v-4.448a2.9 2.9 0 012.891-2.891h5.972"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M34.088 37.32v-4.448a2.9 2.9 0 00-2.891-2.891H25.95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.28 24.562v2.528a2.9 2.9 0 01-2.891 2.891h-5.972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserRole);
export default __webpack_public_path__ + "static/media/addUserRole.accef33039407766c9086e1b4a23d5e6.svg";
export { ForwardRef as ReactComponent };